import {Injectable} from '@angular/core';
import {Storage} from "@ionic/storage";
import {AppConfigService} from "./app-config.service";
import {StateStorageService} from "./state-storage.service";
import {STORAGE_REFRESH_NONCE_KEY, USER_LANGUAGE_KEY} from "../../environments/environment";
import {of} from "rxjs";


@Injectable({
    providedIn: 'root'
})
export class AppInitializer {
    private appInitilized = false;
    private initPromise: Promise<void> | undefined;

    constructor(private storage: Storage,
                private config: AppConfigService,
                private appState: StateStorageService) {

    }

    init(): Promise<void> {
        if (this.appInitilized) {
            return of<void>().toPromise();
        }
        if (this.initPromise) return <Promise<void>>this.initPromise;
        this.initPromise = new Promise<void>((resolve, reject) => {
            let storedLang = '';
            let configLang = '';
            Promise.all([
                this.storage.create().then(() => {
                    Promise.all([
                        this.storage.get(USER_LANGUAGE_KEY).then((lang) => {
                            storedLang = lang;
                        }),
                        this.storage.get(STORAGE_REFRESH_NONCE_KEY).then((nonce) => {
                            this.appState.storedNonce = nonce;
                            this.storage.remove(STORAGE_REFRESH_NONCE_KEY);
                        })
                    ]);
                }),
                this.config.loadAppConfig('./assets/config.json').then(() => {
                    configLang = this.config.getAppConfig('i18n.locale', '');
                    this.appState.apiEndPoint = this.config.getAppConfig('system.apiEndpoint', '');
                })
            ]).then(() => {
                if (storedLang) this.appState.userLanguage = storedLang;
                else this.appState.userLanguage = configLang;
                this.appInitilized = true;
                resolve();
            });
        });
        return this.initPromise;
    }

}
